import { useBaseUser } from '@hooks/queries/useBaseUser';
import { useOrganization } from '@hooks/queries/useOrganization';
import { useQuery } from '@tanstack/react-query';
import { BaseApi } from '../../core/api';
import { PageDTO } from '../../core/models';
import { Property } from '../../core/models/properties';
import { sortAlphabetically } from '../../utils';
import { getPropertiesPermissions } from '../../utils/properties.utils';

export function useProperties({ orgId: orgIdOverride }: { orgId?: string } = {}) {
  const { organization } = useOrganization();
  const { user } = useBaseUser();
  const orgId = orgIdOverride ?? organization?.id;

  const { data: properties, ...rest } = useQuery({
    queryKey: ['properties', { orgId }],
    queryFn: async () => {
      const { data } = await BaseApi.get<PageDTO<Property>>(`/orgs/${orgId}/properties`, {
        params: { include_extended: true },
      });
      const result = await getPropertiesPermissions(data.content);
      return result.toSorted(sortAlphabetically);
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!orgId && !!user,
  });

  return { properties, ...rest };
}
